import { DataBean } from "../DataBean";

export class ByDepreciationValue extends DataBean {


    public async getFixedAssetItemsByDepreciationValue(minPercent:any,maxPercent:any,fixedAssetID:any,regex:any,idAccount:any,idStore:any,state:any,page:any,recordsPerPage:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.advantage.shared.Report_getFixedAssetItemsByDepreciationValue_Number_Number_Number_String_Number_Number_java.util.List_Number_Number", [minPercent,maxPercent,fixedAssetID,regex,idAccount,idStore,state,page,recordsPerPage]);
    }

 
}